import { enumWeightUnit } from '@data-layer/enums/common/enumWeightUnit';
import { WEIGHT_UNIT_KG, WEIGHT_UNIT_LB } from './constants';

export const WEIGHT_UNIT_LIST = [
  {
    label: WEIGHT_UNIT_KG,
    value: enumWeightUnit.KG,
  },
  {
    label: WEIGHT_UNIT_LB,
    value: enumWeightUnit.LB,
  },
];
